import { debounce } from 'lodash';
import { QueryKeys } from 'src/api/keys';
import queryClient from './queryClient';

export const invalidateTodoQueries = debounce(async () => {
  void queryClient.invalidateQueries([QueryKeys.TODO]);
  void queryClient.invalidateQueries([QueryKeys.TODOS]);
  void queryClient.invalidateQueries([QueryKeys.PAGED_TODOS]);
});

export const invalidateActiveClientList = debounce(() => {
  void queryClient.invalidateQueries([QueryKeys.CHECK_EMAIL]);
});
